import React, { useEffect, useMemo, useState } from 'react';
import { Card, CardBody, Col, } from 'reactstrap';
import { useIteamResource } from '../../hook/ShowTable/generic';
import { BasicTab, listRDV } from './config/type';
import RdvSelect from './components/RdvSelect';
import Tabs from './components/Tabs';
import LoaderOrError from './components/LoaderOrError';
import GeneralTable from './components/GeneralTable';
import { useGeneralUrl, useExportUrl } from './hook/useGeneralUrl';
import { useGeneralData } from './hook/useGeneralData';
import Filters, { FormFilter } from './components/Filters'
import { postJson } from '../../hook/request';
import NotesModal from './components/NotesModal';
import Favourite from '../../Components/Widgets/Favourite'

export default function VisualizzaTabella() {
  const { data: rdvs, loading: rdvLoading } = useIteamResource<listRDV>('/rdv?limit=5');
  const [basicTab, setBasicTab] = useState<BasicTab>('generico');
  const [selectedRDV, setSelectedRDV] = useState<string | number>('');


  const [filters, setFilters] = useState<FormFilter>({
    consumer_id: '',
    nominativo: '',
    telefono: '',
    eta: '',
    citta: '',

    new_cluster: '',
    monetary_regional: '',
    generational_cluster: '',
    behavioural_cluster: '',
    primo_acquisto: '',

    segm1_key: '',
    recency: '',
    segm1_frequency: '',
    preferred_rdv: '',
    ultimo_acquisto: '',
    nota: '',
  });

  const [orderGroup, setOrderGroup] = useState<string>('');

  // auto select primo RDV
  useEffect(() => {
    if (rdvs?.list?.length && !selectedRDV) setSelectedRDV(rdvs.list[0].ID);
  }, [rdvs, selectedRDV]);

  const onChangeRDV = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setSelectedRDV(e.target.value);
  };

  const handleFiltersChange = (newFilters: FormFilter, immediate = false) => {
    setFilters(newFilters);
  };

  const handleOrderGroupChange = (value: string) => {
    setOrderGroup(value);
  };

  // Indica se i filtri stanno per essere applicati (stato di transizione)
  const [isFiltering, setIsFiltering] = useState(false);

  const generalUrl = useGeneralUrl(basicTab, selectedRDV, filters, orderGroup);
  const [exporting, setExporting] = useState<null | 'csv' | 'pdf'>(null);


  const [sortState, setSortState] = useState<{ field: string; direction: 'asc' | 'desc' } | null>(null);

  const handleSortChange = (field: string, direction: 'asc' | 'desc') => {
    setSortState({ field, direction });
  };


  async function handleExport(format: 'csv' | 'pdf') {
    if (!selectedRDV) return;
    setExporting(format);

    try {
      // 1️⃣ Chiamata al backend per generare il file
      const { data } = await postJson<{ stato: string; url: string; }>(
        'export/table',
        {
          type: format,
          basicTab,
          selectedRDV,
          filters,
          orderGroup,
          fieldOrder: sortState ?  sortState.field + ' '+ sortState.direction  : null,
          
        }
      );

      const { stato, url } = data;

      if (stato == 'ok') {
        window.open(url, '_blank', 'noopener,noreferrer');
      } else {
        alert('Errore durante l’esportazione: URL non valido o stato non OK.');
      }

    } catch (err) {
      console.error(err);
      alert('Errore durante l’esportazione');
    } finally {
      setExporting(null);
    }
  }


  const { rows, loading: generalLoading, error: generalError } = useGeneralData(generalUrl);

  // Gestisce lo stato di filtraggio
  useEffect(() => {
    const hasFilters = Object.values(filters).some(value => value !== '' && value !== null && value !== undefined);
    if (hasFilters) {
      setIsFiltering(true);

      // Timeout di sicurezza per evitare che rimanga bloccato
      const timeout = setTimeout(() => {
        setIsFiltering(false);
      }, 10000); // 10 secondi di timeout

      return () => clearTimeout(timeout);
    }
  }, [filters]);

  // Resetta lo stato di filtraggio quando i dati arrivano
  useEffect(() => {
    if (!generalLoading && !generalError) {
      setIsFiltering(false);
    }
  }, [generalLoading, generalError]);


  // stato modale
  const [notesOpen, setNotesOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any | null>(null);

  const openNotes = (row: any) => {
    setSelectedRow(row);
    setNotesOpen(true);
  };

  const closeNotes = () => {
    setNotesOpen(false);
    setSelectedRow(null);
  };


  return (
    <div className="page-body pt-4">
      <Col xxl={12} className="mb-lg-3">
        <Card className="p-3">
          <CardBody>
            <div className='d-flex justify-content-between'>
              <h2>Clienteling</h2>
              <Favourite
                percorso={'/visualizza/clienti'}
                nome={'Clienteling'}
              />
            </div>
            <RdvSelect rdvs={rdvs ?? null} selected={selectedRDV} onChange={onChangeRDV} disabled={rdvLoading} />
          </CardBody>
        </Card>
        <Card className="p-3">
          <CardBody>
            <Filters
              filters={filters}
              onFiltersChange={handleFiltersChange}
              onOrderChange={handleOrderGroupChange}
              isFiltering={isFiltering}
              isLoading={generalLoading}
              orderValue={orderGroup}
              onExport={handleExport}
              exporting={exporting}

            />
            <Tabs active={basicTab} onChange={setBasicTab} />
            <div className="mt-3">
              <LoaderOrError loading={!!generalLoading} error={generalError} />
              {!generalLoading && !generalError && <GeneralTable rows={rows} tab={basicTab} onRowClick={openNotes} onSortChange={handleSortChange} />}
            </div>
          </CardBody>
        </Card>
      </Col>

      {/* Modale Note */}
      {selectedRow && (
        <NotesModal
          isOpen={notesOpen}
          onClose={closeNotes}
          clienteID={selectedRow.consumer_id ?? selectedRow.clienteID ?? selectedRow.ID}
          nominativo={selectedRow.nominativo || [selectedRow.nome, selectedRow.cognome].filter(Boolean).join(' ')}
          rdvID={selectedRDV}
          clienteLabel="Consumer ID"
        />
      )}

    </div>
  );
}
